/**
 * @generated SignedSource<<9c4f74d02bc99e0c242a23094a478056>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endts"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invoiceNumber"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startts"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "endts",
        "variableName": "endts"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "invoicenumber",
        "variableName": "invoiceNumber"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "orderdirection",
        "variableName": "orderDirection"
      },
      {
        "kind": "Variable",
        "name": "startts",
        "variableName": "startts"
      }
    ],
    "concreteType": "InvoiceDocumentsConnection",
    "kind": "LinkedField",
    "name": "getdocumentbills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceDocument",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDescription",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerDocumentsBillsQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResellerDocumentsBillsQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "520f1f2a28b46733ab3f472c6596e52c",
    "id": null,
    "metadata": {},
    "name": "ResellerDocumentsBillsQuery",
    "operationKind": "query",
    "text": "query ResellerDocumentsBillsQuery(\n  $accountId: UUID!\n  $invoiceNumber: String!\n  $startts: Datetime\n  $endts: Datetime\n  $orderDirection: Int\n  $first: Int\n  $offset: Int\n) {\n  getdocumentbills(accountid: $accountId, invoicenumber: $invoiceNumber, startts: $startts, endts: $endts, orderdirection: $orderDirection, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      invoiceId\n      invoiceDate\n      invoiceNumber\n      invoiceDescription\n    }\n  }\n}\n"
  }
};
})();

node.hash = "208ae63daf1314530f4cd6cbeb49b6a3";

module.exports = node;
